'use client';

import _defineProperty from "/codebuild/output/src3720/src/s3/01/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/codebuild/output/src3720/src/s3/01/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["keepMounted", "opened", "onClose", "id", "transitionProps", "trapFocus", "closeOnEscape", "returnFocus", "closeOnClickOutside", "withinPortal", "portalProps", "lockScroll", "children", "zIndex", "shadow", "padding", "__vars", "unstyled", "removeScrollProps"],
  _excluded2 = ["key"];
import "core-js/modules/es.date.to-string.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { RemoveScroll } from 'react-remove-scroll';
import { getDefaultZIndex } from '../../core/utils/get-default-z-index/get-default-z-index.mjs';
import { getShadow, getSpacing } from '../../core/utils/get-size/get-size.mjs';
import '@mantine/hooks';
import 'clsx';
import '../../core/MantineProvider/Mantine.context.mjs';
import '../../core/MantineProvider/default-theme.mjs';
import '../../core/MantineProvider/MantineProvider.mjs';
import '../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs';
import '../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs';
import { Box } from '../../core/Box/Box.mjs';
import '../../core/DirectionProvider/DirectionProvider.mjs';
import '../Portal/Portal.mjs';
import { OptionalPortal } from '../Portal/OptionalPortal.mjs';
import { ModalBaseProvider } from './ModalBase.context.mjs';
import { useModal } from './use-modal.mjs';
var ModalBase = forwardRef(function (_ref, ref) {
  var keepMounted = _ref.keepMounted,
    opened = _ref.opened,
    onClose = _ref.onClose,
    id = _ref.id,
    transitionProps = _ref.transitionProps,
    trapFocus = _ref.trapFocus,
    closeOnEscape = _ref.closeOnEscape,
    returnFocus = _ref.returnFocus,
    closeOnClickOutside = _ref.closeOnClickOutside,
    withinPortal = _ref.withinPortal,
    portalProps = _ref.portalProps,
    lockScroll = _ref.lockScroll,
    children = _ref.children,
    zIndex = _ref.zIndex,
    shadow = _ref.shadow,
    padding = _ref.padding,
    __vars = _ref.__vars,
    unstyled = _ref.unstyled,
    removeScrollProps = _ref.removeScrollProps,
    others = _objectWithoutProperties(_ref, _excluded);
  var _useModal = useModal({
      id: id,
      transitionProps: transitionProps,
      opened: opened,
      trapFocus: trapFocus,
      closeOnEscape: closeOnEscape,
      onClose: onClose,
      returnFocus: returnFocus
    }),
    _id = _useModal._id,
    titleMounted = _useModal.titleMounted,
    bodyMounted = _useModal.bodyMounted,
    shouldLockScroll = _useModal.shouldLockScroll,
    setTitleMounted = _useModal.setTitleMounted,
    setBodyMounted = _useModal.setBodyMounted;
  var _ref2 = removeScrollProps || {},
    removeScrollKey = _ref2.key,
    otherRemoveScrollProps = _objectWithoutProperties(_ref2, _excluded2);
  return /* @__PURE__ */jsx(OptionalPortal, _objectSpread(_objectSpread({}, portalProps), {}, {
    withinPortal: withinPortal,
    children: /* @__PURE__ */jsx(ModalBaseProvider, {
      value: {
        opened: opened,
        onClose: onClose,
        closeOnClickOutside: closeOnClickOutside,
        transitionProps: _objectSpread(_objectSpread({}, transitionProps), {}, {
          keepMounted: keepMounted
        }),
        getTitleId: function getTitleId() {
          return "".concat(_id, "-title");
        },
        getBodyId: function getBodyId() {
          return "".concat(_id, "-body");
        },
        titleMounted: titleMounted,
        bodyMounted: bodyMounted,
        setTitleMounted: setTitleMounted,
        setBodyMounted: setBodyMounted,
        trapFocus: trapFocus,
        closeOnEscape: closeOnEscape,
        zIndex: zIndex,
        unstyled: unstyled
      },
      children: /* @__PURE__ */jsx(RemoveScroll, _objectSpread(_objectSpread({
        enabled: shouldLockScroll && lockScroll
      }, otherRemoveScrollProps), {}, {
        children: /* @__PURE__ */jsx(Box, _objectSpread(_objectSpread({
          ref: ref
        }, others), {}, {
          __vars: _objectSpread(_objectSpread({}, __vars), {}, {
            "--mb-z-index": (zIndex || getDefaultZIndex("modal")).toString(),
            "--mb-shadow": getShadow(shadow),
            "--mb-padding": getSpacing(padding)
          }),
          children: children
        }))
      }), removeScrollKey)
    })
  }));
});
export { ModalBase };